var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66671H8.66536V8.66671H7.33203V4.66671ZM7.99203 1.33337C4.31203 1.33337 1.33203 4.32004 1.33203 8.00004C1.33203 11.68 4.31203 14.6667 7.99203 14.6667C11.6787 14.6667 14.6654 11.68 14.6654 8.00004C14.6654 4.32004 11.6787 1.33337 7.99203 1.33337ZM7.9987 13.3334C5.05203 13.3334 2.66536 10.9467 2.66536 8.00004C2.66536 5.05337 5.05203 2.66671 7.9987 2.66671C10.9454 2.66671 13.332 5.05337 13.332 8.00004C13.332 10.9467 10.9454 13.3334 7.9987 13.3334Z",
    fill: "#D99711"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error_outline.bfe84cbe089091d51a990fb39d8d52ee.svg";
export { ForwardRef as ReactComponent };